import { IFamilyMember, INewCareMap, ISupportGroupKey, ISupportGroupMember } from './ICareMap';
import { SupportGroupDataProvider } from './SupportGroupDataProvider';

const householdAvatarPath = '../../assets/images/v2avatars/';
export const TREE_AVATAR = `${householdAvatarPath}6tree.png`;
export const HOUSEHOLD_MEMBER_AVATARS: string[] = [
    `${householdAvatarPath}1bee.png`,
    `${householdAvatarPath}2cat.png`,
    `${householdAvatarPath}3dog.png`,
    `${householdAvatarPath}4otter.png`,
    `${householdAvatarPath}5fish.png`,
    TREE_AVATAR,
    `${householdAvatarPath}7seedling.png`,
    `${householdAvatarPath}8cow.png`,
    `${householdAvatarPath}9horse.png`,
    `${householdAvatarPath}10frog.png`,
    `${householdAvatarPath}11hippo.png`,
    `${householdAvatarPath}12dragon.png`
];

export const isHouseholdAvatar = (url: string | undefined): boolean => {
    return url && url.indexOf(householdAvatarPath) >= 0 ? true : false;
};

// The illustration a care map member is drawn with; one with no photo, illustration or colour of their
// own is drawn with the first. The renderers, the picker and the allocator all read it from here so
// they cannot disagree.
export const getDisplayedAvatar = ({ photo, photoDataURI, avatar, color }: Pick<IFamilyMember, 'photo' | 'photoDataURI' | 'avatar' | 'color'>): string | undefined => {
    if (photo || photoDataURI) {
        return undefined;
    }
    return avatar || (color ? undefined : HOUSEHOLD_MEMBER_AVATARS[0]);
};

export const HOUSEHOLD_MEMBER_COLORS: string[] = [
    '#11789D',
    '#54C0CC',
    '#4763C7',
    '#923DAC',
    '#334155',
    '#059669',
    '#84CC16',
    '#CD5DAC',
    '#F5D14F',
    '#EE6C4E',
    '#EA580C',
    '#E02D3C'
];

export class CareMapFactory {
    static inject = () => [SupportGroupDataProvider];
    constructor(private dataProvider: SupportGroupDataProvider) {}

    getNodeId = (): string => {
        return String(Date.now());
    };

    createBlank = (excludeAvatar?: boolean): INewCareMap => {
        return {
            links: undefined,
            careMapId: undefined,
            patient: {
                avatar: !excludeAvatar ? HOUSEHOLD_MEMBER_AVATARS[0] : undefined,
                contactMethods: [],
                // care recipients created after IH-6884 default new notes to shared with viewers
                notesIsPublic: true,
            },
            household: { members: [], checklists: [] },
            community: { members: [], isRelevant: undefined, checklists: [] },
            financial: { members: [], isRelevant: undefined, checklists: [] },
            school: { members: [], isRelevant: undefined, checklists: [] },
            medical: { members: [], isRelevant: undefined, checklists: [] },
            specialists: { members: [], isRelevant: undefined, checklists: [] },
            social: { members: [], isRelevant: undefined, checklists: [] },
            initialWizardAnswers: {},
            essentialMapComplete: false
        };
    };

    createSupportGroupMember = (supportGroupKey: ISupportGroupKey, roleId?: string): ISupportGroupMember => {
        const role = (roleId ? this.dataProvider.getRoleLabel({ supportGroupKey, roleId }) : undefined);
        return {
            id: this.getNodeId(),
            roleId,
            role,
            contactMethods: [],
        };
    };
}
